// @flow

import React, { type Node, useCallback, useEffect, useState } from 'react';
import { getSafeBoletoBarcode, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import Clipboard from 'react-clipboard.js';
import { useIsMobile } from '@tectonics/hooks';

export function CopyToClipboardButton(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <ButtonCopyToClipboard text={getSafeBoletoBarcode(incomingPayment)} />
  );
}

function ButtonCopyToClipboard({ text }: { text: string }): Node {
  const [copied, setCopied] = useState(false);
  const [timeoutId, setTimeoutId] = useState();
  const isMobile = useIsMobile();

  useEffect(() => {
    return () => clearTimeout(timeoutId);
  }, [timeoutId]);

  const handleClick = useCallback(() => {
    setCopied(true);
    setTimeoutId(setTimeout(() => setCopied(false), 1500));
  }, [setCopied]);

  return (
    <Clipboard
      style={{ ...CopyLinkButtonStyle, width: isMobile ? '100%' : 'calc(50% - 16px)' }}
      onClick={handleClick}
      data-clipboard-text={text}
    >
      {copied ? 'COPIADO' : 'COPIAR CÓDIGO'}
    </Clipboard>
  );
}

const CopyLinkButtonStyle = {
  background: '#2397d4',
  color: 'white',
  fontSize: '14px',
  fontWeight: '700',
  borderRadius: '5px',
  border: 'solid rgb(35, 151, 212)',
  margin: '10px 5px',
  padding: '10px 0',
};
